import {
  loginStart,
  loginSuccess,
  loginFailure,
  resetStart,
  resetSuccess,
  resetFailure,
  changeStart,
  changeSuccess,
  changeFailure,
  forgotStart,
  forgotSuccess,
  forgotFailure,
} from './auth.slice';
import { loginApi, resetApi, changeApi, forgotApi } from '../api/auth.api';

export const loginUser = (credentials) => async (dispatch) => {
  dispatch(loginStart());
  try {
    const response = await loginApi(credentials);
    dispatch(loginSuccess(response.data));
  } catch (error) {
    dispatch(loginFailure(error.response.data));
  }
};

export const resetPassword = (credentials) => async (dispatch) => {
  dispatch(resetStart());
  try {
    const response = await resetApi(credentials);
    dispatch(resetSuccess(response.data));
    return true;
  } catch (error) {
    dispatch(resetFailure(error.response.data));
    return false;
  }
};

export const changePassword = (credentials) => async (dispatch) => {
  dispatch(changeStart());
  try {
    const response = await changeApi(credentials);
    dispatch(changeSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(changeFailure(error.response.data));
    return error.response.data;
  }
};

export const forgotPassword = (email) => async (dispatch) => {
  dispatch(forgotStart());
  try {
    const response = await forgotApi(email);
    dispatch(forgotSuccess(response.data));
    return true;
  } catch (error) {
    dispatch(forgotFailure(error.response.data));
    return false;
  }
};
